import getStyles from './styles';

const HomeContent = (props) => {
  const { sectionRef = null } = props;

  const {
    section,
    sectionH2,
    sectionTagline,
    features,
    feature,
    featureH3,
    featureP
  } = getStyles();

  return (
    <div id="home-section-2">
      <div style={section} id="what-sets-us-apart" ref={sectionRef}>
        <p style={sectionTagline}>
          Get ready to revolutionise your fitness journey with our
          High-Intensity Interval Training (HIIT) programs and innovative beach
          boot camps. Our mission is to make fitness an enjoyable and engaging
          experience, rather than a mundane routine.
        </p>
        <h2 style={sectionH2}>What Sets Us Apart</h2>
        <div style={features}>
          <div style={feature}>
            {/* <img src="https://via.placeholder.com/80" alt="HIIT Icon" /> */}
            <h3 style={featureH3}>HIIT (High Intensity Interval Training)</h3>
            <p style={featureP}>
              Our workouts are designed to push you to your limits, delivering
              maximum results.
            </p>
          </div>
          <div style={feature}>
            {/* <img
              src="https://via.placeholder.com/80"
              alt="Beach Boot Camps Icon"
            /> */}
            <h3 style={featureH3}>Innovative Boot Camps</h3>
            <p style={featureP}>
              Experience the ultimate outdoor workout with cardio, strength, and
              agility training.
            </p>
          </div>
          <div style={feature}>
            {/* <img src="https://via.placeholder.com/80" alt="Community Icon" /> */}
            <h3 style={featureH3}>Community Driven</h3>
            <p style={featureP}>
              Our supportive community will motivate and inspire you to reach
              new heights.
            </p>
          </div>
          <div style={feature}>
            {/* <img
              src="https://via.placeholder.com/80"
              alt="Expert Trainers Icon"
            /> */}
            <h3 style={featureH3}>Expert Trainers</h3>
            <p style={featureP}>
              Our certified trainers will guide you every step of the way for
              maximum results.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeContent;
